import axios from 'axios'

export default {
    getAll: () => axios.get(`/category`),
    getById: categoryId => axios.get(`/category/${categoryId}`),
    add: formData => axios.post(`/category/create`, formData),
    edit: formData => axios.put(`/category/edit`, formData),
    changeStatus: formData => axios.patch(`/category/toggle_status`, formData),
    delete: categoryId => axios.delete(`/category/delete/${categoryId}`),
    searchByName: formData => axios.post(`/category/search`, formData)
}
